export interface AlertFilter {
  macId?: any;
  facilityId?: any;
  floorId?: any;
  pageSize?: number;
  excludeResolved?: boolean;
  /** Keyset cursor from the previous page's nextCursor (alert lists). */
  cursor?: string;
}


export interface Alert {
  id: string;
  type: string;
  macId: string;
  status: 'NotAcknowledged' | 'Acknowledged' | 'Resolved';
  acknowledgeOn: string | null;
  resolvedOn: string | null;
  floorName: string;
  date: string | null;
  timeStamp:string | null;
}

export enum AlertStatusEnum {
  NotAcknowledged = 0,
  Acknowledged = 1,
  Resolved = 2
}


export interface SensorCard {
  icon:          string; // identifier to switch SVG
  label:         string;
  value:         string;
  hasProgress:   boolean;
  progressValue: number; // 0-100
  /** WiFi (and similar): filled signal bars 0–5 */
  signalBars?: number;
}